/* eslint-disable no-unused-vars */
import {
  useElement,
  useState,
  useStaleLayout,
  useRect,
  useEffect,
} from '@nebula.js/stardust';
import picassojs from 'picasso.js';
import picassoQ from 'picasso-plugin-q';
// import numeral from 'numeral';
// import * as d3 from 'd3';

export default function supernova() {
  const picasso = picassojs();
  picasso.use(picassoQ);

  function toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
    );
  }

  return {
    qae: {
      properties: {
        qHyperCubeDef: {
          qDimensions: [],
          qMeasures: [],
          qInitialDataFetch: [{ qWidth: 2, qHeight: 5000 }],
          qSuppressZero: false,
          qSuppressMissing: true,
        },
        showTitles: true,
        title: '',
        subtitle: '',
        footnote: '',
      },
      data: {
        targets: [
          {
            path: '/qHyperCubeDef',
            dimensions: {
              min: 1,
              max: 1,
            },
            measures: {
              min: 1,
              max: 1,
            },
          },
        ],
      },
    },
    component() {
      const element = useElement();
      const layout = useStaleLayout();
      const rect = useRect();

      const [instance, setInstance] = useState();

      useEffect(() => {
        const p = picasso.chart({
          element,
          data: [],
          settings: {},
        });

        setInstance(p);

        return () => {
          p.destroy();
        };
      }, []);

      useEffect(() => {
        if (!instance) {
          return;
        }

        // const colorScale = d3.scaleOrdinal()
        //   .domain(['Men', 'Women', 'Non-Binary'])
        //   .range(['#9EBFCE', '#BE7999', '#204635']);

        instance.update({
          data: [
            {
              type: 'q',
              key: 'qHyperCube',
              data: layout.qHyperCube,
            },
          ],
          settings: {
            scales: {
              color: {
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                  },
                },
                type: 'color',
              },
            },
            components: [
              {
                type: 'legend-cat',
                scale: 'color',
                key: 'legend',
                dock: 'bottom',
                settings: {
                  title: {
                    show: false,
                  },
                  layout: {
                    size: 2,
                  },
                },
              },
              {
                key: 'donut',
                type: 'pie',
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                    props: {
                      num: {
                        field: 'qMeasureInfo/0',
                      },
                    },
                  },
                },
                settings: {
                  padAngle: 0.01,
                  slice: {
                    cornerRadius: 4,
                    innerRadius: 0.4,
                    arc: {
                      ref: 'num',
                    },
                    fill: {
                      scale: 'color',
                    },
                    strokeWidth: 1,
                    stroke: 'rgba(255,255,255,0.5)',
                  },
                },
              },
              {
                type: 'labels',
                displayOrder: 2,
                settings: {
                  sources: [
                    {
                      component: 'donut',
                      selector: 'path',
                      strategy: {
                        type: 'slice',
                        settings: {
                          direction: 'horizontal',
                          fontSize: 11,
                          align: 0.5,
                          justify: 1,
                          labels: [
                            {
                              label: (d) => d.data.num.label,
                              fill: '#FFFFFF',
                              placements: [
                                { position: 'into', fill: '#fff' },
                                // { position: 'outside', fill: '#666' },
                              ],
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              },
              {
                type: 'labels',
                displayOrder: 3,
                settings: {
                  sources: [
                    {
                      component: 'donut',
                      selector: 'path',
                      strategy: {
                        type: 'slice',
                        settings: {
                          direction: 'horizontal',
                          fontSize: 11,
                          align: 1,
                          justify: 1,
                          labels: [
                            {
                              label: (d) => toTitleCase(d.data.label),
                              fill: '#FFFFFF',
                              placements: [
                                // { position: 'into', fill: '#fff' },
                                { position: 'outside', fill: '#666' },
                              ],
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              },
              {
                key: 'tooltip',
                type: 'tooltip',
                displayOrder: 10,
                settings: {
                  filter: (nodes) => nodes.filter((node) => node.key === 'donut'),
                  extract: ({ node }) => {
                    const obj = {};
                    obj.period = node.data.label;
                    obj.goals_perc = node.data.num.label;
                    return obj;
                  },
                  content: ({ h, data }) => {
                    const els = [];
                    data.forEach((node) => {
                      //   // Title
                      //   const elh = h(
                      //     'th',
                      //     {
                      //       colSpan: 2,
                      //       style: { fontWeight: 'bold', 'text-align': 'left' },
                      //     },
                      //     `${toTitleCase(node.period)}`,
                      //   );
                      // Rest of Info
                      const el1 = h('td', {
                        style: { fontWeight: 'bold', 'text-align': 'left' },
                      }, `${toTitleCase(node.period)}`);
                      const el2 = h(
                        'td',
                        {
                          style: {
                            display: 'flex',
                            'align-items': 'center',
                            'justify-content': 'flex-start',
                            padding: '0 0 0 10px',
                          },
                        },
                        `${
                          node.goals_perc
                        }`,
                      );
                      const elr1 = h('tr', {}, [el1, el2]);
                      els.push(elr1);
                    });
                    return h(
                      'div',
                      { style: { display: 'table', margin: '2px' } },
                      els,
                    );
                  },
                  placement: {
                    type: 'pointer',
                    area: 'target',
                    dock: 'auto',
                  },
                },
              },
            ],
            interactions: [
              {
                type: 'native',
                events: {
                  mousemove(e) {
                    this.chart.component('tooltip').emit('show', e);
                  },
                  mouseleave() {
                    this.chart.component('tooltip').emit('hide');
                  },
                },
              },
            ],
          },
        });

        const items = document.querySelectorAll('button[data-component-key]');

        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < items.length; index++) {
          if ('ontouchstart' in document.documentElement === true) {
            items[index].addEventListener('touchstart', (e) => {
              e.preventDefault();
              instance
                .component(e.target.getAttribute('data-component-key'))
                .emit(e.target.getAttribute('data-action'));
            });
          } else {
            items[index].addEventListener('click', (e) => {
              e.preventDefault();
              instance
                .component(e.target.getAttribute('data-component-key'))
                .emit(e.target.getAttribute('data-action'));
            });
          }
        }
      }, [layout, instance]);

      useEffect(() => {
        if (!instance) {
          return;
        }
        instance.update();
      }, [rect.width, rect.height, instance]);
    },
  };
}
